import { instance } from './provider';
import { handleResponse, handleError, CONFIG } from '../utilities';

const BASE_URL = CONFIG.jarvisApiUrl;

const endpoints = {
  upload: {
    rateRequest: `${BASE_URL}/upload/rate-request`,
  },
  dataUploadTemplate: `${BASE_URL}/data-upload-template.xlsx`,
  batchRateTemplate: `${BASE_URL}/batch-rate-template.xlsx`,
  parcelRateTemplate: `${BASE_URL}/parcel-rate-template.xlsx`,
  invoiceAudit: `${BASE_URL}/invoice-audit`,
  runtimeHub: (status?: string, limit?: number) => {
    const params = new URLSearchParams();
    if (status) params.append('status', status);
    if (limit) params.append('limit', limit.toString());
    return `${BASE_URL}/runtime-hub${params.toString() ? `?${params.toString()}` : ''}`;
  },
  results: {
    list: (containerName: string) => `${BASE_URL}/results/${containerName}`,
    download: (containerName: string, blobName: string) =>
      `${BASE_URL}/results/${containerName}/download/${blobName}`,
  },
};

export const jarvisApi = {
  uploadRateRequest: async (formData: FormData) => {
    return instance
      .post(endpoints.upload.rateRequest, formData)
      .then(handleResponse)
      .catch(handleError);
  },
  fetchDataUploadTemplate: async () => {
    return instance
      .get(endpoints.dataUploadTemplate, { responseType: 'blob' })
      .then((response) => {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'data-upload-template.xlsx'); // this is the name with which the file will be downloaded
        link.click();
      })
      .catch(handleError);
  },
  fetchBatchRateTemplate: async () => {
    return instance
      .get(endpoints.batchRateTemplate, { responseType: 'blob' })
      .then((response) => {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'batch-rate-template.xlsx');
        link.click();
      })
      .catch(handleError);
  },
  fetchParcelRateTemplate: async () => {
    return instance
      .get(endpoints.parcelRateTemplate, { responseType: 'blob' })
      .then((response) => {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'parcel-rate-template.xlsx');
        link.click();
      })
      .catch(handleError);
  },
  listResults: async (containerName: string) => {
    return instance
      .get(endpoints.results.list(containerName))
      .then(handleResponse)
      .catch(handleError);
  },
  downloadResult: async (containerName: string, blobName: string) => {
    return instance
      .get(endpoints.results.download(containerName, blobName), {
        responseType: 'blob',
      })
      .then((response) => {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', blobName);
        link.click();
      })
      .catch(handleError);
  },
  submitInvoiceAudit: async (data: {
    fileName: string;
    scacs: string[];
    notifyEmails: string[];
    userName: string;
  }) => {
    return instance
      .post(endpoints.invoiceAudit, data)
      .then(handleResponse)
      .catch(handleError);
  },
  getRuntimeHub: async (status?: 'running' | 'completed' | 'all', limit?: number) => {
    return instance
      .get(endpoints.runtimeHub(status, limit))
      .then(handleResponse)
      .catch(handleError);
  },
};
